import module from '../module';

module.directive('orderHistoryHeader', function () {
    return {
        transclude: true,
        templateUrl: 'modules/profile/views/orderHistoryHeader.html',
        scope: {
            record: '=orderHistoryHeader'
        }
    };
});


// WEBPACK FOOTER //
// ./src/modules/profile/directives/OrderHistoryHeaderDirective.js